'use strict';

var fromCharCode = require('../constant/from-char-code.js');

function safeFromInt(value, base) {
  var code = parseInt(value, base);

  if ( // C0 except for HT, LF, FF, CR, space
  code < 9 || code === 11 || code > 13 && code < 32 || code > 126 && code < 160 || code > 55295 && code < 57344 || code > 64975 && code < 65008 || (code & 65535) === 65535 || (code & 65535) === 65534 || // Out of range
  code > 1114111) {
    return "\uFFFD";
  }

  return fromCharCode(code);
}

module.exports = safeFromInt;